// extracted by mini-css-extract-plugin
export var content = "_ry-1";
export var divider = "_ry-0";